/* IssueKeyNode.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./IssueKeyNode.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Anchor } from '@atlaskit/primitives/compiled';
import { HoverCard } from '@atlaskit/smart-card/hover-card';
import { onJiraIssueKeyClicked } from '../../../../../ai-answer-dialog/analytics';
import { useAnalytics } from '../../../../../common';
var styles = {
  noWrap: "_o5721q9c"
};
export var IssueKeyNode = function IssueKeyNode(_ref) {
  var issuekey = _ref.issuekey,
    url = _ref.url,
    analyticsAttributes = _ref.analyticsAttributes;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  return /*#__PURE__*/React.createElement(HoverCard, {
    url: url
  }, /*#__PURE__*/React.createElement(Anchor, {
    href: url,
    xcss: styles.noWrap,
    onClick: function onClick() {
      return fireAnalyticsEvent(onJiraIssueKeyClicked(_objectSpread(_objectSpread({}, analyticsAttributes), {}, {
        issuekey: issuekey
      })));
    }
  }, issuekey));
};